import styled from 'styled-components';

interface Props {
  alternativeLog: string;
}
const AlternativeInfo = ({ alternativeLog }: Props) => {
  return (
    <Wrapper>
      <Box>
        <div>대체조제 약 확인</div>
        {alternativeLog}
      </Box>
    </Wrapper>
  );
};

export default AlternativeInfo;

const Wrapper = styled.div`
  padding: 16px 0 24px 0;
  margin-bottom: 24px;

  ${({ theme }) => `
    border-bottom: 1px solid ${theme.DF_COLOR.GRAY100};
  `};
`;

const Box = styled.div`
  padding: 20px;
  border-radius: 7px;
  white-space: pre-wrap;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI14SB};
    color: ${theme.DF_COLOR.GRAY500};
    background: ${theme.DF_COLOR.GRAY20};

    div {
      margin-bottom: 12px;
      ${theme.DF_TYPOGRAPHY.UI14R};
      color: ${theme.DF_COLOR.GRAY400};
    }
  `};
`;
